import styled from 'styled-components'
import { WIDE_SCREEN } from 'constants/breakpoints'

export const FieldLine = styled.div`
  text-align: left;
  margin: 1rem 0;
`

export const BottomBar = styled.div`
  display: flex;
  justify-content: space-around;
  @media only screen and (min-width: ${WIDE_SCREEN}) {
    font-size: 22px;
  }
`
export const AvatarBox = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
`
export const AvatarImg = styled.img`
  margin: 0 auto;
  width: 150px;
  border-radius: 20px;
`
